import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/shared.module';
import { NavigationOutletComponent } from './navigation-outlet.component';

@NgModule({
  declarations: [NavigationOutletComponent],
  imports: [CommonModule, SharedModule],
  exports: [NavigationOutletComponent],
})
export class NavigationOutletModule {}
